<mat-form-field
  *ngIf="control"
  appearance="outline"
  ngClass="ks-autocomplete-{{ size }} ks-autocomplete-{{ color }}"
  [class.ks-autocomplete-no-space]="!errors.length"
>
  <mat-label>{{ label }}</mat-label>
  <ng-container *ngIf="!isChipList">
    <input
      *ngIf="optionsVisible"
      #searchInput
      matInput
      [id]="id"
      type="text"
      [placeholder]="placeholder"
      [formControl]="searchControl"
      [required]="required"
      [readonly]="!!control.value"
      (focus)="focused.emit()"
      (blur)="clearSearch()"
    />
    <input
      *ngIf="!optionsVisible"
      #searchInput
      matInput
      [id]="id"
      type="text"
      [placeholder]="placeholder"
      [formControl]="searchControl"
      [matAutocomplete]="autocomplete"
      [required]="required"
      [readonly]="!!control.value"
      (focus)="focused.emit()"
      (blur)="clearSearch()"
    />
    <input matInput hidden [formControl]="control" />
  </ng-container>
  <mat-chip-list *ngIf="isChipList" #chipList [formControl]="control" [required]="required">
    <input
      #searchInput
      matInput
      [id]="id"
      type="text"
      [placeholder]="placeholder"
      [formControl]="searchControl"
      [matAutocomplete]="autocomplete"
      [matChipInputFor]="chipList"
      [matChipInputSeparatorKeyCodes]="allowUserInput ? separatorKeysCodes : []"
      (matChipInputTokenEnd)="allowUserInput ? add($event.value, true) : null"
      (focus)="focused.emit()"
      (blur)="clearSearch()"
    />
    <div class="ks-autocomplete-chips-wrapper">
      <mat-chip *ngFor="let item of control.value" [removable]="removable" (removed)="remove(item)">
        <div
          [innerHTML]="
            (optionType === 'OBJECT' && objectOptionReq?.valueFormatter
              ? objectOptionReq.valueFormatter(item)
              : item
            ) | safe : 'html'
          "
        ></div>
        <span *ngIf="removable" matChipRemove inlineSVG="assets/icons/Close-circle.svg"></span>
      </mat-chip>
    </div>
  </mat-chip-list>
  <mat-autocomplete
    #autocomplete="matAutocomplete"
    [hidden]="optionsVisible"
    (optionSelected)="add($event.option.value)"
  >
    <ng-container *ngIf="filteredOptions$ | async as options">
      <mat-option
        *ngIf="!options.length"
        [disabled]="true"
        [ngClass]="'ks-dropdown-option-' + size + ' ks-dropdown-option-' + color"
      >
        {{ searchControl.value ? 'No records match!' : 'Start typing to get records!' }}
      </mat-option>
      <mat-option
        *ngFor="let option of options"
        [value]="option"
        [disabled]="isSelected(option)"
        [ngClass]="'ks-dropdown-option-' + size + ' ks-dropdown-option-' + color"
      >
        <div
          [innerHTML]="
            (optionType === 'OBJECT' && objectOptionReq?.labelFormatter
              ? objectOptionReq.labelFormatter(option)
              : option
            ) | safe : 'html'
          "
        ></div>
      </mat-option>
    </ng-container>
  </mat-autocomplete>
  <button
    *ngIf="removable && !isChipList && control.value"
    matSuffix
    class="ks-btn-xxs ks-btn-icon-round"
    [ngClass]="'ks-btn-flat-' + color"
    (click)="clearControl()"
  >
    <span inlineSVG="assets/icons/Close.svg"></span>
  </button>
  <span
    *ngIf="!isChipList && !optionsVisible && !showClearBtn"
    matSuffix
    inlineSVG="assets/icons/Chevron-right.svg"
    class="ks-autocomplete-dropdown-icon"
  ></span>
  <mat-error *ngIf="errors.length" class="ks-autocomplete-error">
    <ng-container *ngFor="let error of errors">
      <span
        *ngIf="control.hasError(error.validation) && (control.dirty || control.touched)"
        class="ks-text-1lns"
      >
        <span inlineSVG="assets/icons/Error.svg" class="ks-autocomplete-error__icon"></span
        >{{ error.message }}
      </span>
    </ng-container>
  </mat-error>
</mat-form-field>

<div *ngIf="optionsVisible" class="ks-visible-options ks-scrollbar-neutral ks-mt-4">
  <ng-container *ngIf="!control.value">
    <mat-option
      *ngFor="let option of filteredOptions$ | async"
      [ngClass]="'ks-dropdown-option-' + size + ' ks-dropdown-option-' + color"
      (mousedown)="add(option)"
    >
      <div
        [innerHTML]="
          (optionType === 'OBJECT' && objectOptionReq?.labelFormatter
            ? objectOptionReq.labelFormatter(option)
            : option
          ) | safe : 'html'
        "
      ></div>
    </mat-option>
  </ng-container>
</div>
